import type { FaireProductEntity } from "../../entity_types/product";

export const p_5hzz6g4a5z: FaireProductEntity = {
  token: "p_5hzz6g4a5z",
  type: "product",
  name: "Strawberry Sencha Lemonade - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/ff6b0bd1b036a6ceadac16d6b90e149f3a419a8e05a4d66ce9c6aafe0d0b548b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1cfc13a33afca8fc5f05f466a97284ae4050b57fbbe6d1d13d717585d19fcf3c.jpeg",
    "https://cdn.faire.com/fastly/b2b3ea1282007ce1ffa689cf433f825491947b30f5751a733a88143c430c2254.jpeg"
  ],
  priceDollars: 58,
  description: "SUPERFOOD TEA BLEND \n\nRipe strawberries, juicy lemons and earthy green tea make this refresher the ultimate tea for sun-soaked afternoons. Designed to boost both your mood and your glow, this superfood blend combines natural caffeine with glow-boosting botanicals like strawberries, hibiscus, and rosehips for a crisp, hydrating escape in every sip. \n\n100% ORGANIC - NUTRITIONIST FORMULATED - SUGAR FREE\n\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Sweeten to taste with a drizzle of maple syrup. \n * Iced Tea: Steep 1 tbsp Strawberry Sencha Lemonade in 1 cup of boiling water for at least 5 minutes. Sweeten to taste. Top with 1 heaping cup of ice. \nWhen to Steep:\n\n\n * As a part of your morning ritual. \n * An afternoon pick-me-up. \n * At a summer garden party, at a picnic or with brunch. \n * For a smooth, feel-good boost of energy. \nModerate Caffeine\n\n\n\n",
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:39.570Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
